// while not enforced, https://en.wikipedia.org/wiki/E.164 standard is widely adopted so we can safely assume max length 15
var MAX_PHONE_NUMBER_LENGTH = 15;
var DEFAULT_AVAILABLE_COUNTRY_CODES = ['US', 'CA', 'AU', 'JP', 'DE', 'NZ'];

export { DEFAULT_AVAILABLE_COUNTRY_CODES, MAX_PHONE_NUMBER_LENGTH };
